import $ from "jquery";
import Vue from "vue";
import * as ers from "../../../errorsmessages/errors";
import * as suc from "../../../successmessages/success";
import * as rt from "../../../routes/routes";
import * as ses from "../../../configurations/session/sessioncomplete";
import authservice from "../../../configurations/authentications/auth";
import baseurl from "../../../configurations/baseurl/baseurl";
import router from "../../../router/index";

let Auth = new authservice();

export const actions = {
  newEmployee() {
    let employees = {
      employee_name: $(".employee_name").val(),
      gender: $(".gender").val(),
      phone_no: $(".phone_no").val(),
      id_no: $(".id_no").val(),
      status: $('.status').val(),
      truck_id: $('.truck_id').val()
    };

    $(".creatingEmployeeLoader").show();
    $(".creatingEmployee").hide();
    baseurl.post(rt.addNewEmployee, employees).then(res => {
      $(".creatingEmployeeLoader").hide();
      $(".creatingEmployee").show();
     

      //checking for response codes from backend

      if (res.data.code === 200) {
        //success code
        $(".form-control").val("");
        suc.employeeCreateSuccess();
      } else if (res.data.code === 402) {
        //validation code
        ers.validateErrors();
        $(".form-control").val();
      } else if (res.data.code === 403) {
        //record exist code
        ers.employeeExists();
      } else if (res.data.code === 404) {
        //error code when creatig a record
        ers.errorCreatingEmployee();
      } else if (res.data.code === 405) {
        //no permission code
        ers.noPermissionToCreate();
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        //session expired code
        ses.sessionComplete();
      }
    });
  },

  loadEmployees({ commit }) {
    baseurl.get(rt.loadEmployees).then(res => {
      $(".employeesLoader").hide();

      //checking for response codes from backend

      if (res.data.code === 200) {
        //success code
        commit("STORE_EMPLOYEES", res.data.employees);
      } else if (res.data.code === 404) {
        //error code on loading all employees records
        ers.errorLoadingEmployee();
      } else if (res.data.code === 405) {
        //no permission to read code
        ers.noPermissionToRead();
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        ses.sessionComplete();
      }
    });
  },

  viewEmployee({ commit }, data) {
    commit("STORE_EMPLOYEES_UPDATE", data);
    router.push("/updateemployee");
  },

  leaveApplication({ commit }, employeeId) {
    commit("STORE_EMPLOYEES_UPDATE", employeeId);
    router.push("/leaveapplication");
  },

  advanceApllication({ commit }, employeeId) {
    commit("STORE_EMPLOYEES_UPDATE", employeeId);
    router.push("/advanceapplication");
  },

  employeeUpdate({ commit }) {
    let employees = {
      id: $(".employeeId").val(),
      employee_name: $(".employee_name").val(),
      phone_no: $(".phone_no").val(),
      id_no: $(".id_no").val(),
      gender: $(".gender").val(),
      status: $(".status").val(),
    };

    $(".updatingEmployeeLoader").show();
    $(".updatingEmployee").hide();

    baseurl.post(rt.updateEmployee, employees).then(res => {
      $(".updatingEmployeeLoader").hide();
      $(".updatingEmployee").show();

      //checking for codes from backed

      if (res.data.code === 200) {
        //success code
        suc.employeeUpdateSuccess();
        commit("STORE_EMPLOYEES", res.data.employees);
        setTimeout(() => {
          router.push("/manageemployees");
        }, 3000);
      } else if (res.data.code === 402) {
        //validation code
        ers.validateErrors();
      } else if (res.data.code === 404) {
        //error on updating record code
        ers.errorUpdatingEmployee();
      } else if (res.data.code === 405) {
        //no permission to update code
        ers.noPermissionToUpdate();
        router.push("/manageemployees");
      } else if (res.data.code === 506) {
        //session expired code
        ses.sessionComplete();
      }
    });
  },

  checkKraStrength() {
    var number = /([0-9])/;
    var alphabets = /([a-zA-Z])/;
    if ($("#kra_no").val().length < 11) {
      $("#password-strength-status").removeClass();
      $("#password-strength-status").addClass("weak-kra");
      $("#password-strength-status").html(
        "incorret (should be atleast 11 characters.)"
      );
      $("#password-strength-status").css("color", "red");
    } else {
      if (
        $("#kra_no")
          .val()
          .match(number) &&
        $("#kra_no")
          .val()
          .match(alphabets)
      ) {
        $("#password-strength-status").removeClass();
        $("#password-strength-status").addClass("strong-kra");
        $("#password-strength-status").html("correct kra pin no");
        $("#password-strength-status").css("color", "green");
        $(".creatingEmployee").attr("disabled", false);
      } else {
        $("#password-strength-status").removeClass();
        $("#password-strength-status").addClass("medium-kra");
        $("#password-strength-status").html(
          "Medium (should include alphabets and numbers.)"
        );
        $("#password-strength-status").css("color", "blue");
      }
    }
  }
};
export default actions;



// WEBPACK FOOTER //
// ./src/vuex/modules/employees/actions.js